import { render } from "./TestResultModal.vue?vue&type=template&id=0c2ccd4f&scoped=true&ts=true"
import script from "./TestResultModal.vue?vue&type=script&lang=ts"
export * from "./TestResultModal.vue?vue&type=script&lang=ts"

import "./TestResultModal.vue?vue&type=style&index=0&id=0c2ccd4f&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2ccd4f"]])

export default __exports__